if(pagetype === undefined){
	if(location.pathname.indexOf('/cart') > -1){
		var pagetype = 'cart';
	}else{
		var pagetype = 'common';
	}
}

var front_baseurl = 'https://exvoliveoil.myshopify.com/';

jQuery(function() {

	var jQuerywin = jQuery(window),
	jQuerycloneNav = jQuery('nav#the_header').addClass('clone-nav'),
	jQueryHeader = jQuery('header#header'),
	showClass = 'is-show';
	
	var value = jQuery(document).scrollTop();
		if ( value > 120 ) {
		jQuerycloneNav.addClass(showClass);
		jQueryHeader.addClass('fixed');
		if(pagetype == 'top'){
			jQuery('div.header_logo').addClass('logo-invert');
			jQuery('div.header_cart img.cart-white').hide();
			jQuery('div.header_cart img.cart-black').show();
		}
	} else {
		jQuerycloneNav.removeClass(showClass);
		jQueryHeader.removeClass('fixed');
		if(pagetype == 'top'){
			jQuery('div.header_logo').removeClass('logo-invert');
			jQuery('div.header_cart img.cart-white').show();
			jQuery('div.header_cart img.cart-black').hide();
			//jQuery('div.header_logo').css('background-image','url("logo_tmp1.png")');
			//jQuery('div.header_cart > img').css('filter','invert(0%)');
		}
	}
	$('div.header_cart').fadeIn('fast');

	jQuery(document).on('load scroll', function() {
			var value = jQuery(this).scrollTop();
			if ( value > 120 ) {
			jQuerycloneNav.addClass(showClass);
			jQueryHeader.addClass('fixed');

			if(pagetype == 'top'){
				jQuery('div.header_logo').addClass('logo-invert');
			
				jQuery('div.header_cart img.cart-white').hide();
				jQuery('div.header_cart img.cart-black').show();
			}

		} else {
			jQuerycloneNav.removeClass(showClass);
			jQueryHeader.removeClass('fixed');
			
			if(pagetype == 'top'){
				jQuery('div.header_logo').removeClass('logo-invert');

				jQuery('div.header_cart img.cart-white').show();
				jQuery('div.header_cart img.cart-black').hide();
				//jQuery('div.header_logo').css('background-image','url("logo_tmp1.png")');
				//jQuery('div.header_cart > img').css('filter','invert(0%)');
			}

		}
	});
	
	jQuery(document).on('load scroll', function() {
			var value = jQuery(this).scrollTop();
			if ( value > 120 ) {
			jQuerycloneNav.addClass(showClass);
			jQueryHeader.addClass('fixed');

			if(pagetype == 'top'){
				jQuery('div.header_logo').addClass('logo-invert');
			
				jQuery('div.header_cart img.cart-white').hide();
				jQuery('div.header_cart img.cart-black').show();
			}

		} else {
			jQuerycloneNav.removeClass(showClass);
			jQueryHeader.removeClass('fixed');
			
			if(pagetype == 'top'){
				jQuery('div.header_logo').removeClass('logo-invert');

				jQuery('div.header_cart img.cart-white').show();
				jQuery('div.header_cart img.cart-black').hide();
				//jQuery('div.header_logo').css('background-image','url("logo_tmp1.png")');
				//jQuery('div.header_cart > img').css('filter','invert(0%)');
			}

		}
	});
	
	var totop = jQuery('.totop');
	jQuery(window).scroll(function () {
		if (jQuery(this).scrollTop() > 200) {
			totop.addClass('show');
		} else {
			totop.removeClass('show');
		}
	});
	totop.click(function () {
		jQuery('body, html').animate({ scrollTop: 0 }, 500);
	return false;
	});
	
    jQuery('.navToggle').click(function() {
        jQuery('.navToggle').toggleClass('active');
        if (jQuery(this).hasClass('active')) {
			jQuery('#drawerWrap').css('visibility','visible');
            jQuery('#drawerWrap').addClass('active');
        } else {
			jQuery('#drawerWrap').css('visibility','hidden');
            jQuery('#drawerWrap').removeClass('active');
        }
    });
  
    jQuery('a#onlineshop').click(function() {
        jQuery('.navToggle').toggleClass('active');
        if (jQuery('.navToggle').hasClass('active')) {
			jQuery('#drawerWrap').css('visibility','visible');
            jQuery('#drawerWrap').addClass('active');
        } else {
			jQuery('#drawerWrap').css('visibility','hidden');
            jQuery('#drawerWrap').removeClass('active');
        }
    });
  
});

jQuery(document).ready(function () {
	var swiper = new Swiper('.swiper-container', {
	slidesPerView: 1,
	spaceBetween: 0,
	loop: true,
	effect: 'fade',
	autoplay: {
		delay: 3000,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
		renderBullet: function (index, className) {
			return '<span class="' + className + '">' + '</span>';
		}
	},
	on: {
		init: function () {
		}
	}
	});
});

function swiperShow(){
	jQuery('#sliderLoader').css('opacity','0');
	jQuery('.swiper-wrapper').css('opacity','1.0');
	jQuery('#slider').css('min-height','auto');
}

$(document).ready(function(){

	if(pagetype == 'top'){
		initsearchDo();
	}

	$(document).on('click','a#filter_do',function(e){
		e.preventDefault();
		searchDo();
	});

	$(document).on('click','a#drawerFilter_do',function(e){
		e.preventDefault();
		d_searchDo();
	});	

});

function initsearchDo(e){

		let Data = {};
		Data["PriceRange"] = '';
		Data["Gift"] = '';
		Data["Recommend"] = '';
		Data["Country"] = '';
		Data["Type"] = '';
		Data["Mode"] = 'top';
		let Param = {"Data":Data};
		
		$('div#search_result').empty().prepend('<aside id="search_result_loader"></aside>');
		
	    $.ajax({
	        type: 'GET',
			contentType: 'application/json',
	        url: 'https://exvoliveoil.com/ec_system/webhook/ecfront_items_api.php',
	        async: true,
	        data: Param
	   		}).done((msg) => {
	   		
	   		const $data = $(msg);
			$('div#search_result').hide().html($data).fadeIn('400');
		   		$(".item").matchHeight();
		   		//$.fn.matchHeight._update();
				$('.item_price').each(function(e){
					//$(this).css('position','absolute').css('bottom','0');
				});
				
	    });

}

function searchDo(e){
		

		var PriceArr = "";
		var PriceArr = $('div#filter input[name="PriceRange[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var GiftArr = "";
		var GiftArr = $('div#filter input[name="Gift[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var RecommendArr = "";
		var RecommendArr = $('div#filter input[name="Recommend[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var CountryArr = "";
		var CountryArr = $('div#filter input[name="Country[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var TypeArr = "";
		var TypeArr = $('div#filter input[name="Type[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		
		let Data = {};
		Data["PriceRange"] = PriceArr;
		Data["Gift"] = GiftArr;
		Data["Recommend"] = RecommendArr;
		Data["Country"] = CountryArr;
		Data["Type"] = TypeArr;
		Data["Mode"] = 'top';
		let Param = {"Data":Data};
		
		if(document.documentElement.clientWidth > 1063){
		
		$('div#search_result').empty().prepend('<aside id="search_result_loader"></aside>');
		
	    $.ajax({
	        type: 'GET',
			contentType: 'application/json',
	        url: 'https://exvoliveoil.com/ec_system/webhook/ecfront_items_api.php',
	        async: true,
	        data: Param
	   		}).done((msg) => {
	   		
	   		const $data = $(msg);
			$('div#search_result').hide().html($data).fadeIn('400');
		   		$(".item").matchHeight();
		   		//$.fn.matchHeight._update();
				$('.item_price').each(function(e){
					//$(this).css('position','absolute').css('bottom','0');
				});
				
			    var adjust = 0;
			    var speed = 400;
			    var href= $(this).attr("href");
			    var target = $('#top_item_search_head');
			    var position = target.offset().top + adjust;
			    $('body,html').animate({scrollTop:position}, speed, 'swing');
				
	    });
	    
	    }else{
	    
			var url = new URL(front_baseurl+'pages/list/');
			url.searchParams.append('PriceRange',Data["PriceRange"]);
			url.searchParams.append('Gift',Data["Gift"]);
			url.searchParams.append('Recommend',Data["Recommend"]);
			url.searchParams.append('Country',Data["Country"]);
			url.searchParams.append('Type',Data["Type"]);
			url.searchParams.append('Mode',Data["Mode"]);
			location.href = url;
	    
	    }
	    
}

function d_searchDo(e){
		var PriceArr = "";
		var PriceArr = $('nav#drawerNav_main input[name="PriceRange[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var GiftArr = "";
		var GiftArr = $('nav#drawerNav_main input[name="Gift[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var RecommendArr = "";
		var RecommendArr = $('nav#drawerNav_main input[name="Recommend[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var CountryArr = "";
		var CountryArr = $('nav#drawerNav_main input[name="Country[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		var TypeArr = "";
		var TypeArr = $('nav#drawerNav_main input[name="Type[]"]:checked').map(function() {
            return $(this).val();
		}).get().join();
		
		let Data = {};
		Data["PriceRange"] = PriceArr;
		Data["Gift"] = GiftArr;
		Data["Recommend"] = RecommendArr;
		Data["Country"] = CountryArr;
		Data["Type"] = TypeArr;
		Data["Mode"] = 'top';

		let Param = {"Data":Data};

		var url = new URL(front_baseurl+'pages/list/');
		url.searchParams.append('PriceRange',Data["PriceRange"]);
		url.searchParams.append('Gift',Data["Gift"]);
		url.searchParams.append('Recommend',Data["Recommend"]);
		url.searchParams.append('Country',Data["Country"]);
		url.searchParams.append('Type',Data["Type"]);
		url.searchParams.append('Mode',Data["Mode"]);
		
		location.href = url;
	    
}

function isSmartPhone() {
	if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
		return true;
	} else {
		return false;
	}
}

$(document).ready(function(){
	$(document).on('click', '#drawerFilter_inner > li > a', function(e){
		$(this).toggleClass('drawerFIlter_a_open').siblings('div').toggleClass('drawerFilter_active').slideToggle('fast',function(){
		});
	});
});